import StateKeyCandidateD from "components/vidhansabha/KeyCandidatesD";
import { stateData } from "../../../../constants/state";
import NotFound from "pages/404";

export default function Index(props) {
  return (
    <>
      {props?.found ==false ? <NotFound/>   :<StateKeyCandidateD {...props} />}
    </>
  );
}

const getKeyCandidatesData = async (dataUrl, dataKey) => {
  try {
    // const response = await fetch(
    //   `https://electionresults.intoday.in/elections/2024/assembly-elections/json/ei-dashboard/2024/key-candidate/${
    //     stateName == "Jammu and Kashmir" ? "jammu-and-kashmir" : "haryana"
    //   }-key-candidate.json`
    // );
    const response = await fetch(dataUrl);
    const data1 = await response.json();

    let tempData = data1?.data["ALL KEY CANDIDATES"];

    // if (stateName === "Jammu and Kashmir") {
    //   let keyCandidates = tempData?.filter(
    //     (con) => con?.STATE == "Jammu and Kashmir"
    //   );
    //   setKeyCandidatesData(keyCandidates);
    // } else {
    //   let keyCandidates = tempData?.filter((con) => con?.STATE == "Haryana");
    //   setKeyCandidatesData(keyCandidates);
    // }

    let keyCandidates = tempData?.filter((con) => con?.STATE == dataKey);
    return keyCandidates;
  } catch (error) {
    console.error("Error fetching data: ", error);
    return [];
  }
};

export async function getServerSideProps(ctx) {
  //  let stateName =  "Haryana"
  //  let stateNameHi = "हरियाणा"

  //gmaking state dynamic based on the election state
  const { electionState } = ctx.params;
  console.log(electionState, " plm");
  if(stateData[electionState] == undefined){
    return {
      props : {
        found : false
      }
    }
  }

  //making state dynamic based on the election state
  const stateName = stateData[electionState]["key-candidates"]["stateName"];
  const stateNameHi = stateData[electionState]["key-candidates"]["stateNameHi"];
  const propData = stateData[electionState]["key-candidates"];
  const masterKey = stateData[electionState]["masterConfigKey"];
  const breadCrump = stateData[electionState]["breadCrump"];
  const dataUrlKey = stateData[electionState]["key-candidates"].dataUrlKey;

  const masterConfig = await fetch(
    // `https://static.thelallantop.com/json-configs/public/file.json`
    `${process.env.NEXT_PUBLIC_APP_API_URL}/v1/staticData/json/master-config`
  ).then(async (res) => {
    return await res.json();
  });
  // masterConfigData = masterConfig?.data;
  const masterConfigData = masterConfig?.result?.jsonData?.data?.[masterKey];
  // console.log("master config data in ssr  ", masterConfigData);
  const dataUrl = masterConfigData[dataUrlKey];

  let result = [];

  return getKeyCandidatesData(dataUrl, propData.dataKey)
    .then((res) => {
      result = res;
      return {
        props: {
          stateName,
          stateNameHi,
          propData,
          masterKey,
          keyCandidatesData: result,
          breadCrump,
          electionState,
        },
      };
    })
    .catch((err) => {
      console.log(err, " error in kc");
      return {
        props: {
          stateName,
          stateNameHi,
          propData,
          masterKey,
          breadCrump,
          keyCandidatesData: result,
          electionState,
        },
      };
    });
}
